import React, { useEffect, useState } from 'react'
import RechargeTable from './RechargeTable';
import { Col, Card, Button, Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Navigate, useNavigate } from 'react-router-dom';
import RoutesConstants from '../../../shared-components/Routes/routes.constants';
import { ProductType } from '../../../constants/enum';
import { useStore } from '../../../contexts/StoreProvider';
import { observer } from 'mobx-react';
const RechargePlan = () => {
    const navigate = useNavigate();
    const { preferencesStore, adminStore } = useStore();
    const { getPaymentSetting, allPaymentSettingInfo } = adminStore;
    const lang = preferencesStore.getLanguage;
    const exchangeRateSetting = allPaymentSettingInfo.find(setting => setting.ProductType === 13);
    useEffect(() => {
        getPaymentSetting();
    }, []);
    
    const [Total, setTotal] = useState<number>()

    const data = allPaymentSettingInfo?.filter(s =>
        s.ProductType === ProductType.TrainerRecharge10 ||
        s.ProductType === ProductType.TrainerRecharge25 ||
        s.ProductType === ProductType.TrainerRecharge50 ||
        s.ProductType === ProductType.TrainerRecharge100 ||
        s.ProductType === ProductType.TrainerRecharge150 ||
        s.ProductType === ProductType.TrainerRecharge200 ||
        s.ProductType === ProductType.TrainerRecharge300 ||
        s.ProductType === ProductType.TrainerRecharge500 ||
        s.ProductType === ProductType.TrainerRecharge800 ||
        s.ProductType === ProductType.TrainerRecharge1000
    )
        .map(setting => {
            const mailCount = Number(
                ProductType[setting.ProductType].replace("TrainerRecharge", "")
            );
            return {
                mail: mailCount,
                price:setting.JPY.toLocaleString(),
                productType: setting.ProductType
            };
        });


    return (
        <>
            <div className="dashboar-container  ">
                <div className="dashboard_heading">
                    <div className="container">
                        <h1>
                            <FormattedMessage id="trainer_invitation_recharge" />
                        </h1>
                    </div>
                </div>
                <div className="dashboardTopbar">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <p className="text-dark"><FormattedMessage id="Choose_Your_Recharge" /></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='container'>
                    {
                        lang.toLowerCase() !== "jp" && allPaymentSettingInfo.length > 0 &&
                        <div className="mb-4 py-3 px-2" style={{ 
                            backgroundColor: "var(--body-background)",
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            alignContent: 'center',
                        }}>
                        <p><b className="fw-bold">*</b> <FormattedMessage id="exchange_rate_ref" />: <FormattedMessage id="currency"/>1 = ¥{lang.toLowerCase() === "it" ? exchangeRateSetting?.EUR : exchangeRateSetting?.USD} <i>(<FormattedMessage id="exchange_rate_info"/>)</i></p>
                        </div>
                    }
                    <Row>
                        <Col md="8">
                        {allPaymentSettingInfo.length > 0 &&(
                            <RechargeTable data={data} setTotal={setTotal} />
                        )}
                            {/* <div className=' bg-light p-3'>
                            <Row className='align-items-center'>
                                <Col md="8">
                                    <strong>Total</strong></Col>
                                <Col md="4" className='text-end'>
                                    <strong className='text-dark'>{Total}</strong>
                                    <button className="btn btn-primary ms-3 btn-lg" onClick={() => window.alert("payment successfull")}>Pay Now</button>
                                </Col>
                            </Row>
                            </div> */}
                        </Col>

                        <Col md="4">
                            {/* <h3 className="section-small-title"><FormattedMessage id="Summary" /></h3> */}
                            <div className="paymentCardSummary">
                                <p>
                                    <FormattedMessage id="bank_detail_1"/>
                                </p>
                                <p className='text-dark my-3' style={{"whiteSpace": "pre-line"}}>
                                    <FormattedMessage id="bank_detail_2"/>
                                </p>
                                <p>
                                    <FormattedMessage id="bank_detail_3"/>
                                </p>
                                <Button size="lg" variant='secondary' className='mt-3' onClick={() => navigate(RoutesConstants.ContactUs)}>
                                    <FormattedMessage id="send_message"/>
                                </Button>
                            </div>

                        </Col>
                    </Row>
                    
                </div>

            </div>


        </>
    )
}

export default observer(RechargePlan);
